import role from '../helpers/role';

import NewManualBestlist from '../manualbestlist/NewManualBestlist.vue';
import ManualBestlists from '../manualbestlist/ManualBestlists.vue';
import NewManualBestlistPerformance from '../manualbestlist/NewManualBestlistPerformance.vue';
import Performances from '../manualbestlist/Performances.vue';


const routes = [{
	path: '/manualbestlists',
	name: 'manualbestlists',
	component: ManualBestlists,
	meta: {
		authorize: [{ name: role.ManualBestlistAdmin }],
	},
}, {
	path: '/newmanualbestlist',
	name: 'newmanualbestlist',
	component: NewManualBestlist,
	meta: {
		authorize: [{ name: role.ManualBestlistAdmin }],
	},
}, {
	path: '/updatemanualbestlist/:id',
	name: 'updatemanualbestlist',
	component: NewManualBestlist,
	meta: {
		authorize: [{ name: role.ManualBestlistAdmin }],
	},
},
{
	path: '/manualbestlistperformances/:id',
	name: 'manualbestlistperformances',
	component: Performances,
	meta: {
		authorize: [{ name: role.ManualBestlistAdmin }],
	},
}, {
	path: '/newmanualbestlistperformance/:manualBestlistId',
	name: 'newmanualbestlistperformance',
	component: NewManualBestlistPerformance,
	meta: {
		authorize: [{ name: role.ManualBestlistAdmin }],
	},
}, {
	path: '/updatemanualbestlistperformance/:id',
	name: 'updatemanualbestlistperformance',
	component: NewManualBestlistPerformance,
	meta: {
		authorize: [{ name: role.ManualBestlistAdmin }],
	},
}];

export default routes;
